var _g, _g2, _line, _rect, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouldingTrackFloor01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 12.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.6594,
    width: 139,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 161.7,
    y: 8.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.3557,
    width: 2.6,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 8.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.3557,
    width: 2.6,
    height: 8.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.0384,
    x1: 0,
    y1: 227.3,
    x2: 183,
    y2: 227.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    fill: "none",
    width: 212,
    height: 232
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M186.4,229.5v-4.6h3v0.5H187v1.5h2.4v0.5H187v2.1H186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M190.2,229.5v-4.6h0.6v4.1h2.1v0.5H190.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M193.7,228.4c-0.2-0.4-0.3-0.8-0.3-1.2s0.1-0.9,0.3-1.2c0.2-0.4,0.5-0.6,0.8-0.9c0.3-0.2,0.7-0.3,1.2-0.3 s0.8,0.1,1.2,0.3c0.4,0.2,0.6,0.5,0.8,0.9c0.2,0.4,0.3,0.8,0.3,1.2s-0.1,0.9-0.3,1.2c-0.2,0.4-0.5,0.6-0.8,0.9 c-0.4,0.2-0.7,0.3-1.2,0.3s-0.8-0.1-1.2-0.3C194.2,229.1,193.9,228.8,193.7,228.4z M194.1,227.2c0,0.4,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.5,0.6,0.7c0.3,0.2,0.6,0.2,0.9,0.2c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1 c0-0.5-0.2-1-0.5-1.3s-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5C194.2,226.2,194.1,226.7,194.1,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M199,228.4c-0.2-0.4-0.3-0.8-0.3-1.2s0.1-0.9,0.3-1.2c0.2-0.4,0.5-0.6,0.8-0.9c0.3-0.2,0.7-0.3,1.2-0.3 s0.8,0.1,1.2,0.3c0.4,0.2,0.6,0.5,0.8,0.9c0.2,0.4,0.3,0.8,0.3,1.2s-0.1,0.9-0.3,1.2c-0.2,0.4-0.5,0.6-0.8,0.9 c-0.4,0.2-0.7,0.3-1.2,0.3s-0.8-0.1-1.2-0.3C199.5,229.1,199.2,228.8,199,228.4z M199.3,227.2c0,0.4,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.5,0.6,0.7c0.3,0.2,0.6,0.2,0.9,0.2c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1 c0-0.5-0.2-1-0.5-1.3s-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5C199.5,226.2,199.3,226.7,199.3,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M204.2,229.5v-4.6h1.9c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.4,0.3s-0.3,0.1-0.5,0.1l1.2,1.9h-0.7l-1.2-1.8h-0.9v1.8H204.2z M204.8,227.2h1.2 c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.5-0.3-0.6s-0.4-0.2-0.7-0.2h-1.2V227.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2096,
    x1: 44.4,
    y1: 22.4,
    x2: 44.4,
    y2: 221.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "40.8,23.4 44.4,17.2 48,23.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "40.8,220.4 44.4,226.7 48,220.4  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.2282,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 187.5,28.7 191,25.2 21.1,25.2 24.4,28.7 187,28.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8.3,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.2161,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 170,
    height: 16.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouldingTrackFloor01);
export default __webpack_public_path__ + "static/media/MouldingTrack-Floor01.72b56f561490fa0f2b48c3a9a270bd28.svg";
export { ForwardRef as ReactComponent };